export default "__VITE_ASSET__CcVpKbWV__"